function fillSelectOptions(endNumber) {
	return Array.from({length: Number(endNumber)}).fill(0).map((element, i) => i + 1);
}

export default fillSelectOptions;
